var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#009962"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1225 7.67978C18.3563 7.91465 18.3554 8.29455 18.1205 8.5283L10.283 16.3283C10.0489 16.5613 9.6706 16.5613 9.43652 16.3283L5.87402 12.7828C5.63914 12.5491 5.63823 12.1692 5.87199 11.9343C6.10574 11.6994 6.48564 11.6985 6.72051 11.9323L9.85977 15.0565L17.274 7.67774C17.5089 7.44399 17.8888 7.4449 18.1225 7.67978Z",
    fill: "#E8FFF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.da5cd065.svg";
export { ForwardRef as ReactComponent };